import { I18N_PLATFORM_COMMON_WORD_PATH } from 'constants/i18n';
import { TransportationType } from 'interfaces/IDistance';
import { UnitEnum } from 'interfaces/IPropertySearch';
import { translateText } from 'utils/i18n';

export enum TradeAreaSearchType {
  DISTANCE = 'distance',
  TRAVEL_TIME = 'travelTime',
  GEOSPATIAL = 'geospatialSearch',
}

export enum FindCompsDistanceType {
  DISTANCE = 'distance',
  TRAVEL_TIME = 'travelTime',
}

export const MEASUREMENT_ITEMS = [
  {
    id: 1,
    label: translateText(`${I18N_PLATFORM_COMMON_WORD_PATH}.distance`),
    value: FindCompsDistanceType.DISTANCE,
  },
  {
    id: 2,
    label: translateText(`${I18N_PLATFORM_COMMON_WORD_PATH}.travelTime`),
    value: FindCompsDistanceType.TRAVEL_TIME,
  },
];

export const TRAVEL_MODES = [
  { id: 'Drive', name: TransportationType.DRIVING },
  { id: 'Walk', name: TransportationType.WALKING },
  { id: 'Bike', name: TransportationType.CYCLING },
  { id: 'Drive & Train', name: TransportationType.DRIVING_AND_TRAIN },
  { id: 'Public Transit', name: TransportationType.PUBLIC_TRANSPORT },
];

export const DISTANCE_UNITS = [
  { id: UnitEnum.MILES, name: UnitEnum.MILES },
  { id: UnitEnum.KM, name: UnitEnum.KM },
];
